import React from 'react';
import type { AgentPlatformShellVariant } from '../../utils/agentPlatformTheme';
import { shellClass } from '../../utils/agentPlatformTheme';

type Props = {
  variant?: AgentPlatformShellVariant;
  children: React.ReactNode;
  className?: string;
  contentClassName?: string;
};

export const AgentPlatformShell: React.FC<Props> = ({
  variant = 'default',
  children,
  className = '',
  contentClassName = '',
}) => (
  <div className={`${shellClass(variant)} ${className}`}>
    <div className={`${variant === 'composer' ? 'flex min-h-0 flex-1 flex-col' : 'max-w-7xl mx-auto px-4 sm:px-6 py-6 sm:py-8'} ${contentClassName}`}>
      {children}
    </div>
  </div>
);
